var xP = require('./xP');

/* Controls */
xP.controls.register(require('./controls/_item'));
xP.controls.register(require('./controls/html'));
xP.controls.register(require('./controls/_parent'));
xP.controls.register(require('./controls/form'));
xP.controls.register(require('./controls/fields'));
xP.controls.register(require('./controls/sheet'));
xP.controls.register(require('./controls/foldable'));
xP.controls.register(require('./controls/_field'));
xP.controls.register(require('./controls/string'));
xP.controls.register(require('./controls/text'));
xP.controls.register(require('./controls/file'));
xP.controls.register(require('./controls/button'));
xP.controls.register(require('./controls/submit'));
xP.controls.register(require('./controls/select'));
xP.controls.register(require('./controls/options'));
xP.controls.register(require('./controls/_option'));
xP.controls.register(require('./controls/radio'));
xP.controls.register(require('./controls/checkbox'));
xP.controls.register(require('./controls/email'));
xP.controls.register(require('./controls/phone'));
xP.controls.register(require('./controls/_secret'));
xP.controls.register(require('./controls/password'));
xP.controls.register(require('./controls/number'));
xP.controls.register(require('./controls/datemonth'));
xP.controls.register(require('./controls/date'));
xP.controls.register(require('./controls/datetime'));
xP.controls.register(require('./controls/combobox'));
xP.controls.register(require('./controls/_combolist'));
xP.controls.register(require('./controls/hidden'));

/* Dependencies */
xP.dependencies.register(require('./dependencies/_input'));
xP.dependencies.register(require('./dependencies/classed'));
xP.dependencies.register(require('./dependencies/computed'));
xP.dependencies.register(require('./dependencies/enabled'));
xP.dependencies.register(require('./dependencies/enabled_on_completed'));
xP.dependencies.register(require('./dependencies/_rooted'));
xP.dependencies.register(require('./dependencies/required'));
xP.dependencies.register(require('./dependencies/valid'));
xP.dependencies.register(require('./dependencies/changed'));

/* Repeats */
xP.controls.register(require('./controls/repeats/repeat_append_button'));
xP.controls.register(require('./controls/repeats/repeat_insert_button'));
xP.controls.register(require('./controls/repeats/repeat_remove_button'));
xP.controls.register(require('./controls/repeats/repeat_first_button'));
xP.controls.register(require('./controls/repeats/repeat_prev_button'));
xP.controls.register(require('./controls/repeats/repeat_next_button'));
xP.controls.register(require('./controls/repeats/repeat_last_button'));

require('./repeats');

module.exports = xP;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/index.js
 ** module id = 48
 ** module chunks = 0
 **/